import _ from 'underscore';
import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./CoveragesList.html';
import styles from './CoveragesList-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(template, styles),

        scope: {
            coverages: '=',
            onCovChange: '=',
            coveragesLoading: '=',
            dependentCoverages: '=',
            next: '=?'
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
            $scope.allCoveragesLoaded = true;
            $scope.currentDependentCoverages = [];
            $scope.$watchCollection('coverages', function () {
                var cov = $scope.coverages || [];
                var reqOptCov = _.map(cov, function (c) {
                    if (c.required) {
                        c.coverageCategoryDisplayName = $filter('translate')('ama.policycommon.directives.coverages.heading.Business Insurance Package');
                    } else {
                        c.coverageCategoryDisplayName = $filter('translate')('ama.policycommon.directives.coverages.heading.Optional Coverages');;
                    }
                    return c;
                });
                $scope._coverages = _.groupBy(reqOptCov, 'coverageCategoryDisplayName');
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/coveragesList/CoveragesList.js
// module id = 795
// module chunks = 0